<!-- Content -->
@if (slideAuthorFacade.currentSelectedSlideMedia$ | async; as media) {
  <div class="flex justify-content-center w-full h-full">
    <audio #audioElement
      [src]="mediaControlService.getUrl(media)"
      class="max-w-full max-h-full"
      id="audio-{{ media.id }}"
      preload="auto"
      controls>
    </audio>
  </div>
}
